import { render, staticRenderFns } from "./SleepMattressLive.vue?vue&type=template&id=2d2ecd7a&scoped=true"
import script from "./SleepMattressLive.vue?vue&type=script&lang=js"
export * from "./SleepMattressLive.vue?vue&type=script&lang=js"
import style0 from "./SleepMattressLive.vue?vue&type=style&index=0&id=2d2ecd7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2ecd7a",
  null
  
)

export default component.exports